# frozen_string_literal: true

module Engine
  module Game
    module G1858India
    end
  end
end
